import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../../context/AppContext";

export default function Footer() {
  const { siteSettings } = useApp();

  const siteName =
    siteSettings?.site_name ||
    siteSettings?.siteName ||
    "Solusi IoT Cerdas";

  const siteDescription =
    siteSettings?.site_description ||
    siteSettings?.siteDescription ||
    siteSettings?.site_tagline ||
    siteSettings?.siteTagline ||
    "Website multi CMS dan toko online berbasis backend terpusat.";

  const contactEmail =
    siteSettings?.contact_email ||
    siteSettings?.contactEmail ||
    siteSettings?.email ||
    "-";

  const whatsappNumber =
    siteSettings?.whatsapp_number ||
    siteSettings?.whatsappNumber ||
    siteSettings?.phone_number ||
    siteSettings?.phoneNumber ||
    siteSettings?.phone ||
    "-";

  const address =
    siteSettings?.address ||
    siteSettings?.full_address ||
    "-";

  const copyrightText =
    siteSettings?.copyright_text ||
    siteSettings?.copyrightText ||
    `© ${new Date().getFullYear()} ${siteName}. All rights reserved.`;

  const socialLinksFromObject = siteSettings?.social_links || siteSettings?.socialLinks || {};

  const socialLinksFallback = {
    facebook: siteSettings?.facebook_url || siteSettings?.facebookUrl || "",
    instagram: siteSettings?.instagram_url || siteSettings?.instagramUrl || "",
    twitter: siteSettings?.twitter_url || siteSettings?.twitterUrl || "",
    x: siteSettings?.x_url || siteSettings?.xUrl || "",
    linkedin: siteSettings?.linkedin_url || siteSettings?.linkedinUrl || "",
    youtube: siteSettings?.youtube_url || siteSettings?.youtubeUrl || "",
    tiktok: siteSettings?.tiktok_url || siteSettings?.tiktokUrl || "",
    whatsapp: siteSettings?.whatsapp_url || siteSettings?.whatsappUrl || "",
  };

  const mergedSocialLinks = {
    ...socialLinksFallback,
    ...socialLinksFromObject,
  };

  const socialLinks = Object.entries(mergedSocialLinks).filter(
    ([, value]) => typeof value === "string" && value.trim() !== ""
  );

  return (
    <footer className="border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-10 md:grid-cols-[1.2fr,0.8fr,0.8fr]">
        <div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">
            {siteName}
          </h3>
          <p className="mt-3 text-sm leading-6 text-gray-600 dark:text-gray-300">
            {siteDescription}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wide text-gray-900 dark:text-white">
            Navigasi
          </h4>
          <div className="mt-3 space-y-2 text-sm text-gray-600 dark:text-gray-300">
            <div>
              <Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400">
                Home
              </Link>
            </div>
            <div>
              <Link to="/about" className="hover:text-blue-600 dark:hover:text-blue-400">
                About
              </Link>
            </div>
            <div>
              <Link to="/marketplace" className="hover:text-blue-600 dark:hover:text-blue-400">
                Marketplace
              </Link>
            </div>
            <div>
              <Link to="/blog" className="hover:text-blue-600 dark:hover:text-blue-400">
                Blog
              </Link>
            </div>
            <div>
              <Link to="/gallery" className="hover:text-blue-600 dark:hover:text-blue-400">
                Gallery
              </Link>
            </div>
            <div>
              <Link to="/contact" className="hover:text-blue-600 dark:hover:text-blue-400">
                Contact
              </Link>
            </div>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wide text-gray-900 dark:text-white">
            Kontak
          </h4>
          <div className="mt-3 space-y-2 text-sm text-gray-600 dark:text-gray-300">
            <div>{contactEmail}</div>
            <div>{whatsappNumber}</div>
            <div>{address}</div>

            {socialLinks.length > 0 && (
              <div className="pt-2">
                <div className="flex flex-wrap gap-x-3 gap-y-2">
                  {socialLinks.map(([key, value]) => (
                    <a
                      key={key}
                      href={value}
                      target="_blank"
                      rel="noreferrer"
                      className="capitalize hover:text-blue-600 hover:underline dark:hover:text-blue-400"
                    >
                      {key}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="border-t border-gray-200 px-4 py-4 text-center text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400">
        {copyrightText}
      </div>
    </footer>
  );
}